/* eslint-disable */

import React from 'react';
import { Flex, Inlinelink, useTheme, Typography } from '@creditas-ui/react';

import { InFooterComponent } from './footer.types';
import { Footer, FooterContainer, LogoContainer } from './footer.styles';

const logoUrl = `${process.env.PUBLIC_URL}/images`;

const FooterComponent: React.FC<InFooterComponent> = (
  props: InFooterComponent,
) => {
  const theme = useTheme() as any;
  const currentDate = new Date();
  return (
    <Footer>
      <FooterContainer
        flexDirection={{
          '3xl': 'row-reverse',
          _: 'column',
        }}
        justifyContent={{
          '3xl': 'space-between',
          _: 'start',
        }}
        alignItems={{
          '3xl': 'center',
          _: 'start',
        }}
      >
        <Typography
          variant="bodySmRegular"
          color="neutral.80"
          marginBottom={{
            '3xl': '0px',
            _: '13px',
          }}
        >
          Consulta nuestro {''}
          <Inlinelink
            color={theme.colors.neutral['90']}
            href={`${process.env.REACT_APP_LANDING_URL}/legal/aviso-privacidad`}
            target="_blank"
          >
            Aviso de Privacidad
          </Inlinelink>{' '}
          y nuestros {''}
          <Inlinelink
            color={theme.colors.neutral['90']}
            href={`${process.env.REACT_APP_LANDING_URL}/legal/terminos-condiciones`}
            target="_blank"
          >
            Términos y Condiciones
          </Inlinelink>
        </Typography>

        <Flex flexDirection={'row'} alignItems={'center'}>
          <a href={props.logoGoTo}>
            <LogoContainer>
              <img
                src={`${logoUrl}/icon-logo.svg`}
                alt="Creditas"
                height="100%"
                width="100%"
              />
            </LogoContainer>
          </a>
          <Typography variant="bodyXsRegular" color="neutral.90">
            © {currentDate.getFullYear()} Creditas
          </Typography>
        </Flex>
      </FooterContainer>
    </Footer>
  );
};

export default FooterComponent;
